module.exports = __webpack_public_path__ + "img/600ac69eb3b9dyycca4670d6bc246c42.43926069.png";